export const TABLET_LOWER_BOUND = 768;
export const DESKTOP_UPPER_BOUND = 960;
export const MOBILE_MEDIA_QUERY = `(max-width: ${TABLET_LOWER_BOUND - 1}px)`;
export const TABLET_MEDIA_QUERY = `(min-width: ${TABLET_LOWER_BOUND}px)`;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_UPPER_BOUND}px)`;
export const MATCH_MOBILE = "MATCH_MOBILE";
export const UNMATCH_MOBILE = "UNMATCH_MOBILE";
export const MATCH_TABLET = "MATCH_TABLET";
export const UNMATCH_TABLET = "UNMATCH_TABLET";
export const MATCH_DESKTOP = "MATCH_DESKTOP";
export const UNMATCH_DESKTOP = "UNMATCH_DESKTOP";
export const assetPath = "/bundles/img/svg-icons/symbols.svg";
export const ICON_CHEVRON_UP = `${assetPath}#icon-chevron-up`;
export const ICON_CHEVRON_DOWN = `${assetPath}#icon-chevron-down`;
export const ICON_DELETE = `${assetPath}#icon-delete`;
export const styleUtilities = {
    hidden: "u-hidden",
};
